import React, { useState, useEffect, useRef, useCallback } from "react";
import { useSelector } from "react-redux";
import { detectMob, loadQueryString, numberWithCommas, toMillions, makeGET, makePOST, addDays, returnNumber } from "../../helpers/makeRequest";
import { conf } from '../../config/config'
import 'react-phone-number-input/style.css'
import moment from 'moment';
import $ from 'jquery'
import Spinner from 'react-bootstrap/Spinner';
import Select from "react-select";
import { createFilter } from "react-select";
import { Bar, Pie } from 'react-chartjs-2';
import 'chart.js/auto'
import adnplus from '../../imgs/logo-ADN-plus.png'
import adnlogo from '../../imgs/adn_logo.png'
import ialogo from '../../imgs/ia.png'
$.DataTable = require('datatables.net')
require("datatables.net-responsive");

export const CoachScreen = () => {
    const user = useSelector((state) => state.auth);
    useEffect(() => {
        var x = new Date()

        var d = new Date(x.getFullYear(), x.getMonth() - 6, 1)
        x.setDate(0)
        var d1 = x
        let strDate = document.getElementById("strDate"), endDate = document.getElementById("endDate")
        strDate.setAttribute("value", "2023-01-01")
        strDate.setAttribute("max", moment(d1).format("YYYY-MM-DD"))
        endDate.setAttribute("value", moment(d1).format("YYYY-MM-DD"))
        endDate.setAttribute("min", moment(d).format("YYYY-MM-DD"))

        getDatos();
    }, []);

    const hideEls = (key) => {
        var els = document.getElementsByClassName("hide" + key)
        for (var i = 0; i < els.length; i++) {
            els[i].style.display = "none"
            els[i].classList.remove("d-md-block")
            els[i].classList.remove("d-block")
        }
    }
    const [datos, setDatos] = useState(undefined);
    const [page, setPage] = useState([]);
    const [hostname, setHostname] = useState("");
    const [dataSesiones, setDataSesiones] = useState(undefined);
    const [dataSesiones1, setDataSesiones1] = useState(undefined);
    const [dataFuentes, setDataFuentes] = useState(undefined);
    const [dataMedios, setDataMedios] = useState(undefined);
    const [dataDevices, setDataDevices] = useState(undefined);
    const [hostnames, setHostnames] = useState([])
    const [hostData, setHostData] = useState({ label: "TODOS", value: "TODOS" })
    const [hostnamesFull, setHostnamesFull] = useState([])
    let options = {
        legend: { display: true },
        elements: {
            line: {
                tension: 0
            }
        },
        animation: false,
        scales: {
            y: {
                beginAtZero: true
            }
        },
        responsive: true
    }
    let optionsFuentes = {
        animation: false,
    }

    const [searchTable, setSearchTable] = useState(undefined)
    const [eventosTable, setEventosTable] = useState(undefined)
    const [dimensionesTable, setDimensionesTable] = useState(undefined)

    const replace = (str, rep) => {
        return str.replace(/-/g, " ")
    }

    useEffect(() => {
        if (hostname != "") {
            getDatos()
        }
    }, [hostname])

    const returnPieData = (arr, x, y) => {
        let xValues = arr.slice(0, 4).map(v => v[x])
        let yValues = arr.slice(0, 4).map(v => v[y])
        if (arr.length > 4) {
            xValues = [...xValues, "Otros"]
            yValues = [...yValues.slice(0, 4), yValues.slice((yValues.length - (yValues.length - 4)), yValues.length).reduce((partialSum, a) => partialSum + a, 0)]
        }

        let tempArr = xValues.map((v, i) => {
            return {
                label: v,
                data: yValues[i] || 0
            }
        })

        tempArr.sort((a, b) => (a.data > b.data) ? 1 : ((b.data > a.data) ? -1 : 0))
        xValues = tempArr.map(v => v.label)
        yValues = tempArr.map(v => v.data)

        return { xValues, yValues }
    }

    const getDatos = async () => {
        let page = "", hostTmp = ((hostname != "" && hostname != "TODOS") ? hostname : "")
        const isMobile = detectMob()
        document.getElementById("loading").classList.remove("d-none")
        const params = loadQueryString();

        if (params.hostname) {
            hostTmp = params.hostname
            document.getElementById("hosts").style.display = "none"
        }

        const sampleUrl = "files_protected/sample3.json"
        const url = "report/coachGA?" + "dateStr="
            + document.getElementById("strDate").value + "&dateEnd=" + document.getElementById("endDate").value
            + (hostTmp != "" ? "&hostname=" + hostTmp : "")

        let secs, formatted

        let strDate = document.getElementById("strDate"), endDate = document.getElementById("endDate")
        strDate.setAttribute("max", endDate.value)
        endDate.setAttribute("min", strDate.value)
        endDate.setAttribute("max", "30-06-2024")

        makeGET(params.test ? sampleUrl : url).then(({ data }) => {
            document.getElementById("loading").classList.add("d-none")
            secs = parseInt(data.tiempoTotal + "")
            formatted = moment.utc(secs * 1000).format('HH:mm:ss');
            /*const table = $(`#table1`).DataTable(
              {
                searching: false, info: false, "dom": 'rtip',
                order: [[1, 'desc']],
                "responsive": true
              }
            )*/

            $("#usuarios").text(returnNumber(data.usuariosTotal))
            $("#sesiones").text(returnNumber(data.sesionesTotal))
            $("#sesiones_usuarios").text(returnNumber(parseFloat(data.sesionesTotal / data.usuariosTotal).toFixed(2)))
            $("#vistas").text(returnNumber(data.pageviewsTotal || 0))
            $("#duracion").text(formatted)

            data.months.sort((a, b) => (new Date(a.month) > new Date(b.month)) ? 1 : ((new Date(b.month) > new Date(a.month)) ? -1 : 0))

            const monthsParsed = data.months.map(v => v.monthParsed)
            const monthsPageViews = data.months.map(v => v.pageviews || 0)
            const monthsSesiones = data.months.map(v => v.sesiones)
            const monthsUsuarios = data.months.map(v => v.usuarios)
            const monthsNewUsers = data.months.map(v => v.newUsers)

            /*if (isMobile) {
              document.getElementById("sesionesBar1").style.height = (document.getElementById("sesionesBar1").offsetWidth - 100) + "px"
            }
            if (sesionesChart1) {
              sesionesChart1.destroy()
            }*/
            setDataSesiones({
                labels: monthsParsed,
                datasets: [{
                    label: "Vistas de una página",
                    type: "line",
                    borderColor: "rgb(251, 188, 4)",
                    backgroundColor: "white",
                    data: monthsPageViews,
                    pointBorderWidth: 2,
                    fill: false,
                    tension: 0.2
                },
                {
                    label: "Sesiones",
                    type: "line",
                    borderColor: "rgb(79, 79, 79)",
                    backgroundColor: "white",
                    data: monthsSesiones,
                    fill: false,
                    pointBorderWidth: 2,
                    tension: 0.2
                },
                {
                    label: "Nuevos usuarios",
                    type: "line",
                    borderColor: "rgba(129, 129, 129, 1)",
                    backgroundColor: "white",
                    data: monthsNewUsers,
                    fill: false,
                    pointBorderWidth: 2,
                    tension: 0.2
                },
                {
                    label: "Usuarios",
                    type: "bar",
                    backgroundColor: "#FFD100",
                    data: monthsUsuarios,
                }
                ]
            })
            /*setDataSesiones1({
                labels: monthsParsed,
                datasets: [{
                    label: "Usuarios nuevos",
                    type: "line",
                    borderColor: "#58ac3f",
                    backgroundColor: "#58ac3f",
                    data: monthsNewUsers,
                    fill: false
                },
                {
                    label: "Usuarios",
                    type: "bar",
                    borderColor: "#ac1e75",
                    backgroundColor: "#ac1e75",
                    data: monthsUsuarios,
                }
                ]
            })*/

            setHostnames([{ label: "TODOS", value: "TODOS" }, ...data.hostnames.map(v => {
                return {
                    label: v.hostname, value: v.hostname,
                    min: v.min_date, max: v.max_date
                }
            })])

            if (hostTmp == "") {


                setHostnamesFull(data.hostnames.map(v => {
                    return {
                        label: v.hostname, value: v.hostname,
                        min: v.min_date, max: v.max_date
                    }
                }))
            } else {

            }
            console.log(data)
            setDatos({ ...data })
            setDateChanged(false)
        }).catch((e) => {
            document.getElementById("loading").classList.add("d-none")
            console.log(e)
        })
    };


    const tableRef = useRef()
    // console.log(tableRef)
    const tableName = "search"

    const [showOptions, setShowOptions] = useState(false);
    const handleInputChange = useCallback((typedOption) => {
        if (typedOption.length > 2) {
            setShowOptions(true);
        }
        else {
            setShowOptions(false);
        }
    }, []);
    const dateRangeOverlaps = (a_start, a_end, b_start, b_end) => {
        if (a_start <= b_start && b_start <= a_end) return true; // b starts in a
        if (a_start <= b_end && b_end <= a_end) return true; // b ends in a
        if (b_start < a_start && a_end < b_end) return true; // a in b
        return false;
    }

    const [dateChanged, setDateChanged] = useState(false)
    const submitDate = () => {
        let strDate = document.getElementById("strDate"), endDate = document.getElementById("endDate")
        strDate.setAttribute("max", endDate.value)
        endDate.setAttribute("min", strDate.value)
        setDateChanged(true)
    }
    return (
        <div className="">
            <div className="loading d-none text-center" id="loading">
                <div className="d-flex justify-content-center">
                    <p className="m-0"><Spinner animation="border" role="status" variant="dark"></Spinner></p>
                </div>
                <div className="d-flex justify-content-center">
                    <p style={{ color: "black", zIndex: 10001 }}>Cargando</p>
                </div>
            </div>
            <div id="firstRow" className="row p-3">
                <div className="col-12 col-md-4 pb-3 pt-3 pl-3 text-center">
                    <a className="nav-link font-weight-bold" style={{ color: "black" }} href='/coach'>
                        Coach Digital &nbsp;
                        <img style={{ maxHeight: "30px", maxWidth: "35%" }}
                            src={ialogo} />
                    </a>
                </div>
                <div className="col-12 col-md-4 pt-3">
                    <Select
                        options={(showOptions || hostnames.length < 1000) ? hostnames : []}
                        autoFocus={false}
                        className=""
                        id="hosts"
                        style={{ width: "100%", paddingTop: "1rem!important" }}
                        isSearchable={true}
                        noOptionsMessage={({ inputValue }) => "Escribe 2 o más letras para filtrar"}
                        onInputChange={handleInputChange}
                        value={hostData}
                        filterOption={createFilter({ ignoreAccents: false })}
                        onChange={(e) => {
                            setHostname(e.value)
                            setHostData(e)
                        }}
                    />
                </div>
                <div className="col-12 col-md-4">
                    <div className="row pt-0 pt-md-3 p-3">
                        <div className="input-group">
                            <input type="date" onChange={() => {
                                submitDate()
                            }} id="strDate" className="form-control" />
                            <input type="date" onChange={() => {
                                submitDate()
                            }} id="endDate" className="form-control" />
                            <button disabled={!dateChanged} onClick={getDatos} className="btn btn-primary">
                                <i className="fa fa-search"></i>
                            </button>
                        </div>
                    </div>
                </div>
                {
                    datos &&
                    <div className="col-12 text-center">
                        <p className="h2">Recomendación</p>
                        <p className="h4">
                            {datos.texto}
                        </p>
                    </div>
                }

                <div className="col-12 mt-3 p-3 text-center">
                    {dataSesiones &&
                        <Bar style={{ width: "100%" }} options={options} data={dataSesiones} />
                    }
                </div>
                {/*<div className="col-md-6 col-12 mt-3 p-3">
                    {dataSesiones1 &&
                        <Bar options={options} data={dataSesiones1} />
                    }
                </div>*/}
            </div>
        </div>
    );
}
